import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import {
    useCreateCustomerMutation,
    useGetTaxwithholdingQuery,
    useGetTaxcategoryQuery,
    useGetContactQuery,
    useGetCustomerAddressesQuery,
    useGetIndustryTypeQuery,
    useGetMaketsegmentQuery,
    useGetBAnkAccountQuery,
    useGetPriceListQuery,
    useGetCustomerGroupsQuery,
    useGetTerritoryListQuery,
    useGetLeadListQuery,
    useGetAccoountmangerListQuery,
    useGetCurrencyListQuery
} from '../../../../store/api/customer';

import { useAddressListssQuery } from '../../../../store/api/address'
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import Tab6 from './Tab6'
import { BiLogIn } from 'react-icons/bi';
import { usePageState } from "../../../../Hook/usePageState";
function Customer() {
    const navigate = useNavigate()
    // const [tab, settab] = useState(1)
    const [res, setRes] = useState(false)
    const [brand, setBrand] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);

  
    const [customergrplist, setcustomerGrplist] = useState([])
  
    const [terilist, setTeriList] = useState([])
   
    const [leadlist, setleadlist] = useState([])
   
    const [accountlist, setAccountlist] = useState([])
  

    const [currencylist, setCurrencylist] = useState([])
   
    const [pricelist, setPricelist] = useState([])
   
    const [banklist, setBanklist] = useState([])
    

    const [marketList, setmarketlist] = useState([])
   
    const [industrylist, setIndustrylist] = useState([])
  

    const [addaresslist, setAddresslist] = useState([])
  const [contactlist, setContaclist] = useState([])
  
    const [taxcatlist, setTaxcatlist] = useState([])
    const [taxcategory, settaxCategory] = useState('')
    const [taxwithholdlist, setTaxwithHoldlist] = useState([])
    const [taxwithholds, setTaxwithholds] = useState('')

    const [gstCategory, setGstCategory] = useState('')



    const [status, setStatus] = useState(false)
    const { data: customerGroup, cserror, isLoading } = useGetCustomerGroupsQuery();
    const { data: territory, terror, tisLoading } = useGetTerritoryListQuery();
    const { data: leaddata, lerror, lisLoading } = useGetLeadListQuery();
    const { data: accnountdata, aerror, aisLoading } = useGetAccoountmangerListQuery();
    const { data: currencydata, cerror, cisLoading } = useGetCurrencyListQuery();
    const { data: priceData, perror, pisLoading } = useGetPriceListQuery();
    const { data: bankdata, berror, bisLoading } = useGetBAnkAccountQuery();
    const { data: marketData, merror, misLoading } = useGetMaketsegmentQuery();
    const { data: industryData, ierror, iisLoading } = useGetIndustryTypeQuery();
    const { data: addressdata, caerror, caisLoading } = useGetCustomerAddressesQuery();
    const { data: contactData, coerror, coisLoading } = useGetContactQuery();
    const { data: taxcatData, taerror, taisLoading } = useGetTaxcategoryQuery();
    const { data: taxwithhold, taxerror, taxisLoading } = useGetTaxwithholdingQuery();
    const { data: addresslist } = useAddressListssQuery()
    const [CreateCustomer] = useCreateCustomerMutation()


     const pageStateDefault = {
            tab: 1,
             // === General Details Fields ===
  customername: "",
  customertype: "",
  mobile: "",
  customergrp: "",
  terittory: "",
  lead: "",
  account: "",
  currency: "",
  price: "",
  isGroup: 0,
  bankAccount: "",
  market: "",
  industry: "",
  website: "",
  customerDetails: "",
        // === Address & Contact Fields ===
  primaryadd: "",
  primarycontact: "",
// === Tax Fields ===
  taxId: "",
  gst: "",
  pan: "",
  // === Settings Fields ===
  disable: false,
  delivery: false,
  frozen: false,
  salesorder: false,
          };
        
          const [pageState, setPageState] = usePageState(`Create Customer`, pageStateDefault);
        
        
          const { tab,customername,customertype,mobile,customergrp,terittory,lead,account,currency,price,isGroup,bankAccount,market,industry,website,customerDetails, primaryadd,primarycontact,taxId,gst,pan,disable,delivery,frozen,salesorder} = pageState;

 const handleTabChange = (tabNumber) => {
    setPageState({ ...pageState, tab: tabNumber });
  };
    const handleSubmit = async () => {
        const payload = {
            customer_name: pageState.customername,
            customer_type: pageState.customertype,
            mobile_no: pageState.mobile,
            customer_group: pageState.customergrp,
            territory: pageState.terittory,
            lead_name: pageState.lead,
            account_manager: pageState.account,
            default_currency: pageState.currency,
            default_price_list: pageState.price,
            is_internal_customer: pageState.isGroup,
            industry: pageState.industry,
            market_segment: pageState.market,
            website: pageState.website,
            customer_details: pageState.customerDetails,
            customer_primary_address: pageState.primaryadd,
            customer_primary_contact: pageState.primarycontact,
            tax_id: pageState.taxId,
            tax_category: pageState.taxcategory,
            tax_withholding_category: pageState.taxwithholds,
            gstin: pageState.gst,
            pan: pageState.pan,
            gst_category: pageState.gstCategory,
            so_required: pageState.salesorder,
            dn_required: pageState.delivery,
            is_frozen: pageState.frozen,
            disabled: pageState.disable
        };
        try {
            const response = await CreateCustomer(payload).unwrap();
            console.log('Customer created:', response);
            setError('Customer created successfully!');
            setptype('Success');
            setStatus(true)
            setShowError(true);
            setTimeout(() => {
                navigate('/master/customer/customer-list')
            }, 2000);

        } catch (error) {
  try {
    // Parse server messages if available
    const parsedMessages = JSON.parse(error?.data?._server_messages || "[]");

    // Find the first red/error message
    const errorMsgObj =
      parsedMessages
        .map((msg) => JSON.parse(msg))
        .find((m) => m.indicator === "red" || m.raise_exception) ||
      // fallback: use first message if no red found
      JSON.parse(parsedMessages[0] || "{}");

    setError(errorMsgObj?.message || "An unknown error occurred.");
  } catch (e) {
    console.error("Error parsing frappe response", e);
    setError("Unexpected error occurred.");
  }

  setptype("Error");
  setShowError(true);
}

    };

    useEffect(() => {
        if (taxwithhold) {
            setTaxwithHoldlist(taxwithhold.data)
        }
    }, [taxwithhold])

    useEffect(() => {
        if (taxcatData) {
            setTaxcatlist(taxcatData.data)
        }
    }, [taxcatData])

    useEffect(() => {
        if (contactData) {
            setContaclist(contactData.data)
        }
    }, [contactData])

    useEffect(() => {
        if (addressdata) {
            setAddresslist(addressdata.data)
        }
    }, [addressdata])

    useEffect(() => {
        if (industryData) {
            setIndustrylist(industryData.data)
        }
    }, [industryData])

    useEffect(() => {
        if (addresslist) {
            setAddresslist(addresslist.data)
        }
    }, [addresslist])

    useEffect(() => {
        if (marketData) {
            setmarketlist(marketData.data)
        }
    }, [marketData])

    useEffect(() => {
        if (bankdata) {
            setBanklist(bankdata.data)
        }
    }, [bankdata])

    useEffect(() => {
        if (priceData) {
            setPricelist(priceData.data)
        }
    }, [priceData])

    useEffect(() => {
        if (currencydata) {
            setCurrencylist(currencydata.data)
        }
    }, [currencydata])

    useEffect(() => {
        if (accnountdata) {
            setAccountlist(accnountdata.data)
        }
    }, [accnountdata])

    useEffect(() => {
        if (customerGroup) {
            setcustomerGrplist(customerGroup.data)
        }
    }, [customerGroup])

    useEffect(() => {
        if (territory) {
            setTeriList(territory.data)
        }
    }, [territory])

    useEffect(() => {
        if (leaddata) {
            setleadlist(leaddata.data)
        }
    }, [leaddata])

    const customertypelist = [
        { "name": 'Company' },
        { "name": 'Individual' },
        { "name": 'Partnership' },
    ];

    const GstCategorylist = [
        { "name": "Unregisterd" },
        { "name": "Registerd Composition" },
        { "name": "Registerd Regular" },
        { "name": "SEZ" },
        { "name": "Overseas" },
        { "name": "Deemed Exort" },
        { "name": "UIN Holders" },
        { "name": "Tax Deductors" },
        { "name": "Tax Collectors" },
        { "name": "Input Service Distributor" },
    ]

    return (
        <>
            <FormLayoutTwo
                title="New Customer"
                breadcrumbs={[
                    { label: "Customer" },
                    { label: "Customer List", url: "/master/customer/customer-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>
                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            iconSize={12}
                            onClick={handleSubmit}
                        >
                            save
                        </Button>

                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            onClick={handleSubmit}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                  <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: 1 }}>
      {/* ========== Tabs Header ========== */}
      <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
        <div className="d-flex justify-content-between align-items-end">
          <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
            {/* ------------- General Details Tab ------------- */}
            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
              <a
                className={
                  tab === 1
                    ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                    : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                }
                href="javascript:void(0);"
                onClick={() => handleTabChange(1)}
              >
                General Details{" "}
                {tab === 1 ? (
                  <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                ) : (
                  <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                )}
              </a>
            </li>

            {/* ------------- Address & Contact Tab ------------- */}
            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
              <a
                className={
                  tab === 4
                    ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                    : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                }
                href="javascript:void(0);"
                onClick={() => handleTabChange(4)}
              >
                Address & Contact{" "}
                {tab === 4 ? (
                  <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                ) : (
                  <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                )}
              </a>
            </li>

            {/* ------------- Tax Tab ------------- */}
            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
              <a
                className={
                  tab === 5
                    ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                    : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                }
                href="javascript:void(0);"
                onClick={() => handleTabChange(5)}
              >
                Tax{" "}
                {tab === 5 ? (
                  <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                ) : (
                  <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                )}
              </a>
            </li>

            {/* ------------- Settings Tab ------------- */}
            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
              <a
                className={
                  tab === 6
                    ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                    : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                }
                href="javascript:void(0);"
                onClick={() => handleTabChange(6)}
              >
                Settings{" "}
                {tab === 6 ? (
                  <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                ) : (
                  <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                )}
              </a>
            </li>
          </ul>

          {/* Attachment section */}
          <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: "12px" }}>
            <span style={{ position: "relative", top: "-1px" }}>
              <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
            </span>
            <span className="fw-semibold" style={{ color: "#4B002B" }}>
              Attachments
            </span>
          </div>
        </div>
      </div>

                    <div className=" " style={{ background: '' }}>
                        <div className="row">
                              {tab === 1 && (
                            <div
                                className="col-12 "
                                style={{
                                    visibility: tab == 1 ? "visible" : "hidden",
                                    height: tab == 1 ? "auto" : "0px",
                                }}
                            >
                                <div className="sidebarbox m-0 ">

                                  
                                        <Tab1
                                         pageState={pageState}
                                                  setPageState={setPageState}
 handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                  onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                            customertypelist={customertypelist}
                                            customergrplist={customergrplist}
                                            terilist={terilist}
                                            leadlist={leadlist}
                                            accountlist={accountlist}
                                            currencylist={currencylist}
                                            banklist={banklist}
                                            pricelist={pricelist}
                                             industrylist={industrylist}
                                              marketList={marketList}
                                           
                                           
                                        />
                                   
                                </div>
                            </div>
                             )}
                               {tab === 4 && (
                            <div
                                className="col-12 "
                                style={{
                                    visibility: tab == 4 ? "visible" : "hidden",
                                    height: tab == 4 ? "auto" : "0px",
                                }}
                            >
                                <div className="sidebarbox m-0 ">
                                    
                                        <Tab4
                                       pageState={pageState}
                  setPageState={setPageState}
                  handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                  primaryadd={pageState.primaryadd}
                  primarycontact={pageState.primarycontact}
                  addresslistss={addaresslist}
                                            contactlist={contactlist}
                                        />
                                    
                                </div>
                            </div>
                            )}
                             {tab === 5 && (
                            <div
                                className="col-12 "
                                style={{
                                    visibility: tab == 5 ? "visible" : "hidden",
                                    height: tab == 5 ? "auto" : "0px",
                                }}
                            >
                                <div className="sidebarbox m-0 ">
                                   
                                        <Tab5
                                         pageState={pageState}
                                                  setPageState={setPageState}
 handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                  onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                            taxcatlist={taxcatlist}
                                            taxwithholdlist={taxwithholdlist}
                                            GstCategorylist={GstCategorylist}
                                        />
                                    
                                </div>
                            </div>
                            )}
                            {tab === 6 && (
                            <div
                                className="col-12 "
                                style={{
                                    visibility: tab == 6 ? "visible" : "hidden",
                                    height: tab == 6 ? "auto" : "0px",
                                }}
                            >
                                <div className="sidebarbox m-0 ">
                                    
                                        <Tab6
                                          pageState={pageState}
                                                  setPageState={setPageState}
 handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                  onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                        />
                                    
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    )
}

export default Customer